var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.423,
    height: 19.423,
    viewBox: "0 0 19.423 19.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_181",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 181",
    transform: "translate(-953 -72.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_178",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 178",
    transform: "translate(579.77 -373.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M390.106,433.055H375.777a2.047,2.047,0,0,0-2.047,2.047v16.376l4.094-4.094h12.282a2.047,2.047,0,0,0,2.047-2.047V435.1A2.047,2.047,0,0,0,390.106,433.055Z",
    transform: "translate(0 13.13)",
    fill: "none",
    stroke: "#4477c0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_180",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 180",
    transform: "translate(733.959 -10.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_59",
    "data-name": "\\u30D1\\u30B9 59",
    d: "M228.848,91.965h-.9a4.688,4.688,0,0,1-.048-.635,3.416,3.416,0,0,1,.815-2.123,3.124,3.124,0,0,0,.972-1.967,1.181,1.181,0,0,0-1.319-1.248,2.261,2.261,0,0,0-1.307.42l-.289-.731a3.351,3.351,0,0,1,1.8-.516,1.936,1.936,0,0,1,2.159,1.967,3.853,3.853,0,0,1-1.151,2.374,2.845,2.845,0,0,0-.756,1.811,2.306,2.306,0,0,0,.012.288Zm-1.175,1.9a.717.717,0,0,1,.707-.768.764.764,0,1,1-.707.768Z",
    fill: "#4477c0",
    stroke: "#4477c0",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQA);
export default __webpack_public_path__ + "static/media/q_a.96d0cfd4393fa027c2213c6efd151476.svg";
export { ForwardRef as ReactComponent };